import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

function cleanupLegacyServiceWorkers() {
  if (typeof window === 'undefined') {
    return;
  }

  window.addEventListener('load', () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations()
        .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
        .catch(() => {});
    }

    if ('caches' in window) {
      window.caches.keys()
        .then((cacheNames) => Promise.all(
          cacheNames
            .filter((cacheName) => /höhenrettung|hohenrettung/i.test(cacheName))
            .map((cacheName) => window.caches.delete(cacheName))
        ))
        .catch(() => {});
    }
  });
}

cleanupLegacyServiceWorkers();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
